import { CheckBadgeIcon } from '@heroicons/react/24/outline';
import React from 'react';
import Tag from '../common/Tag';

interface Props {
  tier: number;
  hol?: boolean;
}

function getTierLabel(
  tier: number,
  hol?: boolean,
): [
  string,
  'purple' | 'gray' | 'darkBlue' | 'lightBlue' | 'orange' | 'red' | 'maroon' | 'darkGreen' | null | undefined,
] {
  switch (tier) {
    case 1:
      return hol ? ['Certified Hands on Lab', 'purple'] : ['Certified solution', 'purple'];
    case 2:
      return hol ? ['Hands on Lab', 'gray'] : ['Solution', 'gray'];
    case 3:
      return hol ? ['Community scaled Hands on Lab', 'gray'] : ['Community scaled', 'gray'];
    case 4:
      return hol ? ['Community Hands on Lab', 'gray'] : ['Community', 'gray'];
    default:
      return hol ? ['Hands on Lab', 'gray'] : ['Solution', 'gray'];
  }
}

export default function TierTag({ tier, hol }: Props) {
  const [tierLabel, color] = getTierLabel(tier, hol);

  if (tierLabel === '') {
    return null;
  }
  return (
    <Tag color={color}>
      {tierLabel}
      {tier === 1 && <CheckBadgeIcon className="h-4 w-4 ml-1 text-dataops-secondary-purple" />}
    </Tag>
  );
}
